import { cn } from "@/shared/utils/cn";
import type { ReactNode, TableHTMLAttributes } from "react";

interface BasicProps {
  children?: ReactNode;
  className?: string;
}

export const TableContainer = ({ children, className = "" }: BasicProps) => {
  return <div className={`overflow-x-auto ${className}`}>{children}</div>;
};

export const Table = ({
  children,
  className = "",
  ...props
}: TableHTMLAttributes<HTMLTableElement>) => {
  return (
    <table
      className={`w-full border-collapse border-spacing-0 text-left [&_td]:align-middle ${className}`}
      {...props}
    >
      {children}
    </table>
  );
};

export const Th = ({ children, className = "", ...props }: any) => {
  return (
    <th
      className={`whitespace-nowrap px-[2rem] py-[1rem] text-[1.3rem] font-thin text-white first:px-[2rem] ${className}`}
      {...props}
    >
      {children}
    </th>
  );
};

export const Thead = ({ children, className = "", ...props }: any) => {
  return (
    <thead className={`bg-primary pb-[1rem] ${className}`} {...props}>
      {children}
    </thead>
  );
};

export const TableBody = ({
  isVisible,
  children,
  className = "",
  ...props
}: any) => {
  return (
    <tbody
      className={`relative [&_tr]:cursor-pointer [&_tr]:transition-all [&_tr:hover]:bg-grey-secondary [&_tr_td]:whitespace-nowrap [&_tr_td]:px-[2rem] [&_tr_td]:py-[1.25rem] [&_tr_td:first-child]:rounded-l-[0.5rem] [&_tr_td:last-child]:rounded-r-[0.5rem] [&_tr:nth-child(even)]:bg-table-blue [&_tr:nth-child(odd)]:bg-grey-secondary [&_tr:nth-child(even):hover]:bg-grey-blue [&_tr:nth-child(odd):hover]:bg-grey-blue ${className}`}
      style={{ display: isVisible ? "table-row-group" : "none" }}
      {...props}
    >
      {children}
    </tbody>
  );
};

export const TableFiltersContainer = ({
  children,
  className = "",
  ...props
}: any) => {
  return (
    <div className={cn("transition-all duration-200", className)} {...props}>
      {children}
    </div>
  );
};
